'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/quick-quote/components/age.js';
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _age = require('@marmalade/form/lib/questions/age');
var _age2 = _interopRequireDefault(_age);
var _constants = require('../../constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function MultiAge(_ref) {
  var rest = _objectWithoutProperties(_ref, []);
  return _react2.default.createElement(_age2.default, Object.assign({
    min: _constants.age.min,
    max: _constants.age.max
  }, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: this
  }));
}
exports.default = MultiAge;